import React, { Component } from 'react';
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";

class AdkBannerDefaultOffers extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            offerToUpdate: null,
            offers: []
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
        this.loadOffers();
    }

    loadOffers() {
        this.setState({ isLoading: true });

        API.AdkBanner.DefaultOffers.get()
            .then(offers => this.setState({ offers, isLoading: false }));

    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, offerToUpdate: null });
    }

    handleFormSubmit(offer) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            offerToUpdate: null
        });

        let promise;

        if(offer.update) {
            const { id } = offer;

            delete offer.id;

            promise = API.AdkBanner.DefaultOffers.update(id, offer)
        }
        else promise = API.AdkBanner.DefaultOffers.save(offer);

        promise.then(() => this.loadOffers());
    }

    handleUpdateBtnClick(offer) {
        this.setState({ isShowForm: true,  offerToUpdate: offer });
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.AdkBanner.DefaultOffers.remove(id).then(() => this.loadOffers());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['adk-banner-EU'], 'defaultOffers', 8083)
            .then(() => this.setState({ isLoading: false }));
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                offer={this.state.offerToUpdate}/>;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Default Offers"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </ButtonGroup>
                    </Col>
                </Row>

                {this.getForm()}

                <Table offers={this.state.offers} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick}/>
            </Container>
        );
    }
}

export default AdkBannerDefaultOffers;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffers/index.js